import makeStyles from '@mui/styles/makeStyles';
import colors from 'global/styles/colors';

const useStyles = makeStyles((theme) => ({
  openMenu: {
    width: 180,
    justifyContent: 'flex-start',
    position: 'relative',
    fontWeight: 'bold',

    '& .more': {
      position: 'absolute',
      right: 0,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      marginLeft: theme.spacing(2),
      color: theme.palette.primary.light,
      textTransform: 'lowercase',
    },
  },
}));

export default useStyles;

const IMAGESIZE = 190;

export const rowStyles = makeStyles((theme) => ({
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  centerrow: {
    justifyContent: 'center',
  },
  mobileButtonRow: {
    margin: theme.spacing(1),
  },
  photo: {
    display: 'inline-block',
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    position: 'relative',
    cursor: 'pointer',
    width: (p) => p.imageSize,
    height: (p) => p.imageSize,

    '& .data': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'absolute',
      backgroundColor: 'rgba(0,0,0,0.2)',
      left: 0,
      right: 0,
      bottom: 0,
      height: 40,
      padding: 2,
      color: 'white',

      '& .title': {
        display: 'inline-block',
        textOverflow: 'ellipsis',
        position: 'relative',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        left: 0,
        width: IMAGESIZE - (24 + 4),
      },

      '& .subtitle': {
        display: 'inline-block',
        textOverflow: 'ellipsis',
        position: 'relative',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        left: 24,
        fontSize: 14,
        width: IMAGESIZE - (24 + 4),
      },

      '& .iconWrap': {
        width: 24,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'column',

        '& .MuiIcon-root': {
          fontSize: 20,
        },
      },
    },

    '& .IMAGE': {
      width: '100% !important',
      height: `100% !important`,

      '& img': {
        top: `0 !important`,
        left: '0 !important',
        width: '100% !important',
        height: '100% !important',
      },
    },
  },

  hlRow: {
    height: (p) => (p.isMobile ? undefined : 120),
    position: 'relative',
    padding: theme.spacing(1),

    flexDirection: (p) => (p.isMobile ? 'column' : 'row'),
    alignItems: (p) => (p.isMobile ? 'flex-start' : 'center'),

    '&:hover': {
      backgroundColor: (p) => (p.canSelect ? undefined : 'rgba(0,0,0,0.1)'),
      cursor: (p) => (p.canSelect ? undefined : 'pointer'),
    },

    '& .loadingMask': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    '& .hlRow': {
      width: (p) => (p.isMobile ? '100%' : '25%'),
      fontSize: 14,
      marginTop: (p) => (p.isMobile ? theme.spacing(4) : theme.spacing(2)),

      '& .templateTitle': {
        fontStyle: 'italic',
      },
    },

    '& .imageListContainer': {
      width: '75%',
      display: 'flex',
      overflow: 'hidden',
      overflowX: 'auto',
      marginLeft: theme.spacing(1),
      marginTop: theme.spacing(2),
    },

    '& .title': {
      position: 'absolute',
      top: theme.spacing(1),
      fontSize: 20,
      fontWeight: 'bold',
      marginBottom: theme.spacing(1),
    },
  },

  captionContainer: {
    width: '100%',
    '& .link': {
      color: colors.blue,
      fontStyle: 'italic',
      cursor: 'pointer',
      margin: `${theme.spacing(1)} 0`,

      '&.small': {
        fontSize: 12,
      },
    },

    '& .headerRow': {
      flexDirection: (p) => (p.isMobile ? 'column' : 'row'),
      alignItems: (p) => (p.isMobile ? 'flex-start' : 'center'),
      fontSize: (p) => (p.isMobile ? 12 : 16),
    },

    '& .description': {
      fontSize: 12,
    },
  },
  spacer: {
    margin: `0 ${theme.spacing(2)}`,
  },
}));
